<template>
  <div>
    <div class="header_wrap">
      <div style="width: 60%">
        <el-steps style="width: 100%" align-center :active="3">
          <el-step
            :title="
              transportTypeCode == 'KY'
                ? $t('i18n_Air_Freight_Information')
                : transportTypeCode == 'HY'
                ? $t('i18n_ocean_freight_information')
                : transportTypeCode == 'LY'
                ? $t('i18n_land_transportation_information')
                : ''
            "
          ></el-step>
          <el-step :title="$t('i18n_Value_added_service')"></el-step>
          <el-step :title="$t('i18n_shipping_information')"></el-step>
          <el-step :title="$t('i18n_confirm_order')"></el-step>
          <el-step :title="$t('i18n_order_completed')"></el-step>
        </el-steps>
      </div>
    </div>
    <!-- --------------------------------内容 -->
    <div class="center_wrap">
      <div class="wrap_l">
        <div
          style="display: flex; display: -webkit-flex; align-items: center"
        ></div>
        <div class="Item_list">
          <!-- 委托信息 -->
          <div
            style="
              display: flex;
              display: -webkit-flex;
              align-items: center;
              margin-bottom: 20px;
            "
          >
            <img src="../../assets/weituo.png" alt="" />
            <p class="tittype">{{ $t("i18n_Order_Information") }}</p>
          </div>
          <div class="header_text">
            <div class="count_center" style="margin-right: 50px">
              <span class="cangkutit" style="color: red; font-weight: bold">{{
                fromFABck.namec
              }}</span>
              <span class="ckttext" style="margin-top: 10px">{{
                $t("i18n_Original_Port")
              }}</span>
            </div>
            <div class="cangkutit" style="margin-right: 50px">
              <!-- <img src="../../assets/images/setIcon.png" alt=""> -->
              <img v-show="transportTypeCode == 'KY'" style="width: 60px"
              src=../../../static/images/KY.png alt="" /> <img
              v-show="transportTypeCode == 'HY'" style="width: 60px"
              src=../../../static/images/HY.png alt="" /> <img
              v-show="transportTypeCode == 'LY'" style="width: 60px"
              src=../../../static/images/LY.png alt="" />
            </div>
            <div class="count_center">
              <span class="cangkutit" style="color: red; font-weight: bold"
                >{{ toFABck.country }}
                <span style="margin-left: 15px; font-size: 16px">{{
                  toFABck.namec
                }}</span>
              </span>
              <span class="ckttext" style="margin-top: 10px">{{
                $t("i18n_Destination")
              }}</span>
            </div>
          </div>
          <div class="good_count">
            <div v-for="(item, index) in BoxShowLable" :key="index">
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="shouMargin">
                    {{ $t("i18n_Product_Type") }}:{{ item.typeName }}
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="shouMargin">
                    {{ $t("i18n_Total_weight") }}：{{ item.weight }}
                    <span class="ckttext">KG</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="shouMargin">
                    {{ $t("i18n_Total_pieces") }}：
                    {{ item.goodsDTOnum }}
                    <span class="ckttext" style="margin-left: 4px">{{
                      $t("i18n_Pieces")
                    }}</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="shouMargin">
                    {{ $t("i18n_total_volume1") }}：{{ item.cbm
                    }}<span class="ckttext" style="margin-left: 4px">CBM</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="shouMargin">
                    {{ $t("i18n_Total_boxes") }}：{{
                      item.boxNum ? item.boxNum : 1
                    }}<span class="ckttext" style="margin-left: 4px">{{
                      $t("i18n_Boxes")
                    }}</span>
                  </div>
                </el-col>
              </el-row>
              <div v-show="BoxShowLable.length > 1">
                <el-divider></el-divider>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="wrap_R" :class="auto_fixed ? 'auto_fixed' : ''">
        <p
          style="
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #343434;
          "
        >
          {{ $t("i18n_cost_calculation") }}
        </p>
        <div class="OrderDetails">
          <div class="Item_Right animate__animated animate__bounceInRight">
            <p class="tit">{{ $t("i18n_shipping_cost") }}</p>
            <p
              class="coutText"
              v-for="(item, index) in FBATransmoney.goodsTypeFeeDTOS"
              :key="index"
            >
              <span class="littit">{{ item.goodsTypeName }}</span>
              <span class="fontString"
                >{{ item.currency }}{{ item.amount }}</span
              >
              <span style="margin-left: 10px">({{ item.calDesc }})</span>
            </p>
            <p class="coutText">
              <span class="littit">{{ $t("i18n_subtotal") }}</span>
              <span class="fontString"
                >{{ FBATransmoney.currency }}{{ FBATransmoney.amount }}</span
              >
            </p>
          </div>
          <div
            class="Item_Right animate__animated animate__bounceInRight"
            v-show="THFdata.checked"
          >
            <p class="tit">{{ $t("i18n_pickup_fee") }}</p>
            <p class="coutText">
              <span class="littit">{{
                $t("i18n_pickup_at_original_port")
              }}</span>
              <span class="fontString"
                >{{ THFdata.currency }}{{ THFdata.amount }}</span
              >
              <span
                class="littit"
                style="float: left; width: 100%"
                v-if="THFdata.maxKilometer > 0"
                >({{ THFdata.minKilometer }}--{{ THFdata.maxKilometer }}){{
                  $t("i18n_Kilometers")
                }}</span
              >
            </p>
          </div>
          <!-- 暂时隐藏全境派尾程派送费 -->
          <!-- <div
            class="Item_Right animate__animated animate__bounceInRight"
            v-if="isGlobalDelivery && !isGlobalSea"
          >
            <p class="tit">{{ $t("i18n_global_delivery_cost") }}</p>
            <p class="coutText">
              <span class="littit">{{ $t("i18n_subtotal") }}</span>
              <span class="fontString"
                >{{ GlobalDelivery.currency }}{{ GlobalDelivery.amount }}</span
              >
              <span style="margin-left: 10px"
                >{{ "(" }}{{ GlobalDelivery.calDesc }}{{ ")" }}</span
              >
            </p>
          </div> -->

          <div class="Item_Right" v-if="formData.totalExpense">
            <p class="tit">{{ $t("i18n_Value_Added_Service_Fee") }}</p>
            <div
              class="coutText animate__animated animate__bounceInRight"
              v-for="(item, index) in formData.feeItemDTOS"
              :key="index"
              v-show="item.checked"
            >
              <!-- <span class="littit">{{ item.feeName }}</span> -->
              <span class="littit" v-if="item.feeCode === 'CLEF'">{{ $t('i18n_customs_declaration_with_tax_refund') }}</span>
              <span class="littit" v-else>{{ item.feeName }}</span>
              <span class="fontString"
                >{{ item.currency }}&nbsp;&nbsp;{{ item.amount }}&nbsp;&nbsp;({{
                  item.calDesc
                }})</span
              >
            </div>
            <div
              class="coutText animate__animated animate__bounceInRight"
              style="color: #ff3030"
            >
              <span class="littit" style="color: #ff3030"
                >{{ $t("i18n_subtotal") }}:</span
              >
              <span class="fontString">{{ formData.totalExpense }}</span>
            </div>
          </div>
          <div class="Item_Right">
            <p class="coutText" style="justify-content: flex-start; gap: 10px">
              <span class="littit">{{ $t("i18n_total_cost") }}</span>
              <span
                v-for="(item, index) in this.newArray"
                :key="index"
                v-show="item.amount > 0"
              >
                <span
                  ><span class="fontString" v-show="item.currency != ''">{{
                    item.currency
                  }}</span>
                  <span
                    class="fontString"
                    v-show="item.amount > 0"
                    style="margin-left: 5px; margin-right: 5px"
                    >{{ item.amount }}</span
                  ></span
                >
                <span v-show="index == newArray.length - 1 ? false : true"
                  >+</span
                >
              </span>
            </p>
            <p class="coutText">
              <span class="littit">{{ $t("i18n_Covert_to_CNY") }}</span>
              <span class="fontString">CNY {{ calculatePrice }}</span>
            </p>
          </div>
          <div class="goodsValueCount">
            <div class="goodsValue_name">货值统计</div>
            <div class="goodsValue_fat">
              <div class="goodsValue_box">箱数:{{ getBoxNum }} 箱</div>
              <div class="goodsValue_value">货值:{{ getGoodsValue }} USD</div>
            </div>
          </div>
        </div>
        <div style="width: 100%; margin-top: 30px; float: left">
          <div style="width: 100%">
            <el-button style="width: 100%" @click="pathToback()">{{
              $t("i18n_Previousstep")
            }}</el-button>
          </div>
          <div style="width: 100%; margin-top: 10px">
            <el-button
              @click="Qdshowcount()"
              style="width: 100%; background: #5ab53c; color: #ffffff"
              >{{ $t("i18n_confirm_order") }}</el-button
            >
          </div>
          <div style="width: 100%; margin-top: 10px; text-align: center">
            <el-checkbox v-model="checkedQd"
              >{{ $t("i18n_tick_term") }}
            </el-checkbox>
            <el-button
              @click.stop="openPolicy()"
              type="text"
              style="text-decoration: underline"
              >《{{ $t("i18n_Carriage_goods_agreement") }}》</el-button
            >
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :title="$t('i18n_Are_your_confirm_order')"
      center
      :visible.sync="dialogTableVisible"
      width="520px"
    >
      <div class="showDalog">
        <div class="header_text">
          <div class="count_center" style="margin-right: 50px">
            <span class="cangkutit" style="color: red">{{
              fromFABck.namec
            }}</span>
            <span class="ckttext" style="margin-top: 10px">{{
              $t("i18n_receving_warehosue")
            }}</span>
          </div>
          <div class="cangkutit" style="margin-right: 50px">
            <img v-show="transportTypeCode == 'KY'" style="width: 60px"
            src=../../../static/images/KY.png alt="" /> <img
            v-show="transportTypeCode == 'HY'" style="width: 60px"
            src=../../../static/images/HY.png alt="" /> <img
            v-show="transportTypeCode == 'LY'" style="width: 60px"
            src=../../../static/images/LY.png alt="" />
          </div>
          <div class="count_center">
            <span class="cangkutit" style="color: red"
              >{{ toFABck.namec }}
            </span>
            <span class="ckttext" style="margin-top: 10px">{{
              $t("i18n_destination")
            }}</span>
          </div>
        </div>
        <div
          class="goodlist"
          style="
            margin-top: 40px;
            width: 100%;
            float: left;
            padding: 0px 40px;
            box-sizing: border-box;
            margin-bottom: 30px;
          "
        >
          <!-- <p style="#999999">商品信息</p>
          <div
            style="padding: 5px"
            v-for="(item, index) in busLcljobsBeforeGoodsDTOList"
            :key="index"
          >
            <p style="font-weight: bold; color: #333333">
              {{ item.goodsname }},{{ item.piece }}件,{{ item.cbm }}CMB,{{
                item.weight
              }}KG
            </p>
          </div> -->
          <p style="#999999">{{ $t("i18n_estimated_cost") }}</p>
          <div style="padding: 5px">
            <p style="font-weight: bold; color: #333333">
              CNY {{ calculatePrice }}
            </p>
          </div>
        </div>
        <div class="Qdbtn LR_center" style="margin-top: 30px">
          <div
            @click="dialogTableVisible = false"
            class="btnstyle"
            style="
              height: 35px;
              background: #ffffff;
              border: 2px solid #dcdcdc;
              border-radius: 35px;
            "
          >
            {{ $t("i18n_cancel") }}
          </div>
          <div
            @click="pathToNext()"
            class="btnstyle"
            style="
              border: 1px solid #5ab53c;
              font-size: 30rpx;
              background: #ff3939;
              border-color: #ff3939;
              color: #ffffff;
            "
          >
            {{ $t("i18n_confirm_order") }}
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 协议条款弹窗 -->
    <el-dialog title="服务条款" center :visible.sync="policyDialog" width="50%">
      <div slot="title">
        <p style="font-size: 16px; line-height: 20px">
          <b>货物承运电子协议</b>
        </p>
        <p style="font-size: 16px; line-height: 20px">
          <b>Carriage of goods agreement</b>
        </p>
      </div>
      <div style="line-height: 18px">
        <!-- <p style="text-align: end">编号：</p>
        <p>甲方:亦邦物流在线平台注册用户</p>
        <p>统一社会信用代码：</p>
        <p>地址：</p>
        <p style="margin-bottom: 20px">（以下统称“甲方”）</p>

        <p>乙方：亦邦（深圳）国际物流有限公司</p>
        <p>统一社会信用代码：91440300717851662C</p>
        <p>
          地址：深圳市南山区粤海街道高新区社区科技南路18号深圳湾业园科技生态园12栋裙楼810
        </p>
        <p style="margin-bottom: 20px">（以下统称“乙方”）</p>

        <p>
          甲、乙双方经友好协商，根据相关法律和货运行规，由甲方委托乙方代办国际航空/海洋/快递货物出口运输业务及相关单证交接、报关、境内陆路运输、货物跟踪查询、保险等辅助业务事宜达成如下协议：
        </p>
        <p>第一条 合作内容：</p>
        <p>
          乙方负责根据甲方指示，为甲方提供国际航空/海洋/快递货物出口运输业务，包括在线海运订舱/空运订舱、报关、海运/空运干线、清关和目的国境内派送/电商物流下单等相关配套服务。
        </p>
        <p>第二条 双方责任：</p>
        <p>
          2.1甲方委托乙方承运货物，甲方必须严格遵守中华人民共和国的法律、法令、规定，国际条例和交通部的有关规定。
        </p>
        <p>
          2.2甲方委托乙方出运的货物，需提前订舱，将货物资料传真至乙方，特别是超限、大票、特殊货物，甲方应事先与乙方取得联系，以便乙方安排舱位及确定是否能收运。
        </p>
        <p>2.3乙方负责提供运价和相关专业咨询。</p>
        <p>
          2.4乙方收到货物后如发现重量和尺码与订舱不符，应立即通知甲方，在得到甲方确认后才可出运。如果因甲方回复迟缓延误运输，所造成的后果由甲方负责。乙方保证在运输过程中为货物提供必要的防护、防雨、封闭空间等措施，确保货物无整箱短缺、无人为原因造成的任何损害。如有上述问题，乙方应承担货损和丢货的赔偿责任，
        </p>
        <p>
          2.5如果委托乙方代理报关，甲方应整理好报关资料，并对报关资料的准确性和真实性负责。乙方应合理审查甲方提供的单证，如发现错误需及时告知甲方修改。若甲方提供任何错误、不实、过时或不完整或具误导性的资料，由此造成的损失由甲方自行承担，乙方不承担任何相关责任。若由于乙方责任造成报关单证错误或遗失，乙方须依法向甲方承担责任。
        </p>
        <p>2.6乙方收到货物后及时安排出运，并将相关单据完整及时回传给甲方。</p>
        <p>
          2.7若乙方因各种不可抗力原因无法按预定时间出运，应及时书面或者电话通知甲方，并按甲方的合理要求采取跟进措施。
        </p>
        <p>
          2.8对由于承运人或不可抗力因素造成货物延误交货、货损等事故，按航空公司运单及相关国际航空运输公约处理善后事宜，乙方不承担责任，但应积极协助甲方解决。
        </p>
        <p>
          2.9乙方在甲方授权范围内，作为运输代理人，根据甲方合法合规且无损乙方利益的指示和要求代理甲方处理相关事宜的后果由甲方承担。乙方超越授权范围或未按照甲方指示或要求处理的相关事宜，由乙方承担全部责任。
        </p>
        <p>
          2.10乙方负责根据甲方托运单内容将甲方的货物运输至甲方的指定地点，交付甲方指定的国际运输承运公司或收货人。乙方在甲方指定装货地点装货完毕签收之时起至运抵甲方指定收货地由甲方指定的国际运输承运公司或收货人签收之时止，为乙方责任区间，由乙方负责。
        </p>
        <p>
          2.11甲方有权要求乙方按委托指令将货物运送到目的地，并有权知悉业务进展情况及服务过程；在未办理提货、发货手续之前，甲方有权变更或取消委托内容，由此产生的合理费用由甲方承担。
        </p>
        <p>
          2.12如果甲方发运的物品因甲方或与货物自身相关原因被起运港或目的港海关、相关政府部门或其他执法部门查验、扣货、销毁等，相关损失由甲方自行承担。因此给乙方造成损失的，甲方应赔偿乙方损失。如非因甲方自身原因造成前述情况的，乙方应及时通知甲方，并协助甲方积极处理，如为乙方或乙方雇佣人员或委托的第三方造成的，则乙方应向甲方承担赔偿责任。
        </p>
        <p>第三条 货物交接具体办法：</p>
        <p>3.1甲方发货前需真实完整地填写国际货物托运书，传真或E-MAIL给乙方。</p>
        <p>3.2乙方联系甲方确定具体的收货时间和地址或由甲方亲自送货入仓。</p>
        <p>
          3.3乙方根据甲方提供的报关资料制单（运单的重量以货站的核重为准）、报关。
        </p>
        <p>3.4乙方应在完成交货至最终收货仓后48小时内提供签收回执给甲方。</p>
        <p>第四条 收费：</p>
        <p>
          有关费用结算，甲方应当按双方邮件、或者书面约定的各项费用及时足额支付。乙方向甲方收取的费用，以运输前确认为主，乙方保留根据市场行情进行调整资费的权利，但必须邮件、或者书面通知甲方,并得到甲方的书面确认回复。
        </p>
        <p>第五条 结算：</p>
        <p>5.1双方约定采取下列第一种作为运费结算方式：</p>
        <p>
          第一种方式：票结。乙方每次账单确认后第一时间将账单提供给甲方进行确认，如收到后有异议须在三个工作日内反馈，超过三个工作日视为确认，核对无误后，甲方须于五个工作日向乙方结算，运费按要求超过时间未付的，乙方可采取必要途径向甲方追讨欠款，并有权追究甲方违约责任。
        </p>
        <p>
          第二种方式：设定最高限额的月结。
          结算期为每月1日至月末最后一天，当月最高限额为人民币100,000元，大写人民币拾万元整。如当月内甲方应付乙方的费用达到最高额度时，甲方应预先支付人民币100,000元，且在10个工作日内将此金额支付到乙方指定账户，因无理由拖欠付款产生的货物滞留等相关法律、经济责任由甲方承担。对剩余未付部份或当月未达到最高限额时按如下操作：
        </p>
        <p>
          A、乙方于每月5日前提供上月1号至月末最后一天的业务账单给甲方，甲方在收到账单之日起3个工作日内完成确认工作，以书面形式通知乙方；双方确认无误后，乙方向甲方出具正式税务发票及相关材料；甲方于收到发票起
          10个工作日内将上月1号至月末最后一天运费汇入乙方指定账户。
        </p>
        <p>
          B.
          如甲方对费用有争议，须在收到对账单后3个工作日内书面形式通知乙方，双方必须在该票业务的次月25日前（以甲方提供货物托运输的日期作为该业务的产生日期）协商确定，并于商定的付款日期内付款，以免影响次月运作；如甲方在收到对账单后3个工作日内未提出异议视为对账单所列费用已认可。
        </p>
        <p>
          5.2甲方应在协定时间（如遇假期顺延）内支付款项，如逾期不付，则乙方有权按拖欠时间每日加收总款项的5‰的滞纳金。甲方逾期付款超过45天以上的，乙方有权留置甲方交付的货物及与货物相关的单证（包括运输单证），责任由甲方承担。
        </p>
        <p>5.3运费结算方式为：现金，支票，转帐，汇至乙方指定帐户里。</p>
        <p>第六条 知识产权:</p>
        <p>
          6.1乙方拥有双方合作中的电子商务运营系统及其操作规范的所有知识产权，由乙方提供的包括不限于项目运营信息系统、仓储物流的有关规范、流程、图表、说明等文字知识产权属乙方独自所有，甲方不得利用技术手段予以篡改或侵犯；
        </p>
        <p>
          6.2任意一方需在得到对方的书面授权后，方可使用对方的商标、标识。任意一方并不能因为本合同自动获得对方商标、标识的使用权。
        </p>
        <p>第七条 保密责任</p>
        <p>
          7.1双方对本合同以及在履行本合同中接触到的双方的经营情况、商业信息、客户名单、技术资料等将严格保密，非经对方事先书面同意和合同正常履行之需，不得向第三方泄漏。
        </p>
        <p>
          7.2甲方承诺不披露或公开费率、条款和价格方案等，除非法律强制要求对此做出披露或公开。
        </p>
        <p>7.3双方应保证本方雇员履行上述义务。</p>
        <p>7.4本义务不因本合同的解除、终止、撤消而失效。</p>
        <p>第八条 违约责任：</p>
        <p>
          8.1甲方未按合同约定的期限向乙方支付费用，应按照实际违约天数，每日向乙方支付未付款金额的__0.05_%作为违约金。
        </p>
        <p>
          8.2因甲方提供资料不齐全而导致乙方无法完成送达任务，损失完全由甲方承担;乙方在运输过程中如果发现甲方所提供的收货人联系方式有误，应及时与甲方联系寻求解决方案，因此导致乙方未能按照约定时间交付货物，乙方不负责任，对乙方造成损失的，甲方应负责赔偿。
        </p>
        <p>
          8.3甲方如隐瞒货物属性，由此给乙方或第三人造成损失的，由甲方负全部赔偿责任。
        </p>
        <p>8.4其他违反合同约定行为。</p>
        <p>
          注：违反本合同约定的，违约方除需赔偿损失外，还应承担守约方包括但不限于诉讼费、律师费、交通费等合理损失。
        </p>
        <p>第九条 协议变更与解除：</p>
        <p>
          9.1本协议生效后，未经对方同意，任何一方不得擅自变更或解除本协议。需要变更或解除本协议时，应经双方协商一致，达成书面协议。未签署另行达成的书面协议前，本协议条款仍然有效。
        </p>
        <p>
          9.2甲乙双方任何一方有违反本协议条款时，构成根本违约时，另一方有权解除本协议，违约一方应于获取通知后的七个工作日内给另一方结算所有应付（应收）款项，并承担相应违约责任。
        </p>
        <p>第十条 争议解决：</p>
        <p>10.1本协议在执行过程中如发生争议，适用中华人民共和国法律解决。</p>
        <p>
          10.2本协议在执行过程中发生争议时，双方可协商解决；不能协商解决的，可向乙方所在地人民法院提起诉讼。
        </p>
        <p>
          10.3在上述磋商或诉讼期间，双方应继续履行争议部分之外的本合同项下各自义务。
        </p>
        <p>第十一条 协议生效 ：</p>
        <p>11.1本协议用户在亦邦物流在线平台勾选同意后生效。</p>
        <p>第十二条 其他约定：</p>
        <p style="margin-bottom: 30px">12.1本协议未尽事宜，由双方协商解决；</p>

        <p style="margin-bottom: 20px">（以下无正文，为签署页）</p>

        <p>甲方：亦邦物流在线平台注册用户</p>
        <p>乙方：亦邦（深圳）国际物流有限公司</p>
        <p>签订地点：深圳</p> -->

        <p><b>更新发布时间：2024年8月7日</b></p>
        <p style="margin-bottom: 25px"><b>Update: August 7, 2024</b></p>
        <serviceAgreement :showTitle="false"></serviceAgreement>
        <!-- <p style="text-indent: 2em;">本协议由您与亦邦（深圳）物流有限公司共同缔结，本协议具有合同效力。本协议中亦邦（深圳）物流有限公司称为亦邦。</p>
        <p style="text-indent: 2em;">This agreement is entered into by you and Cititrans (Shenzhen) Logistics Co., LTD.
          This agreement has the effect of contract. Cititrans (Shenzhen) Logistics Co., Ltd. is referred to as Cititrans
          in this agreement.</p>
        <p>1. 协议生效Agreement comes into effect</p>
        <p>
          1.1.您应该在与Cititrans签署协议之前仔细阅读全部协议内容，只要您在线同意本协议，即视为您已仔细阅读协议全部内容，本协议即在您和Cititrans之间产生法律效力，届时您不应以未阅读本协议的内容为理由，主张本协议无效或要求撤销本协议。
        </p>
        <p>You should read it carefully before signing the agreement with Cititrans all agreements, as long as you agree
          to this agreement online, that as you have read the agreement carefully the whole content, this agreement is
          between you and Cititrans produced legal effectiveness, then you should not be on the grounds of not reading the
          content of this agreement, this agreement is invalid or ask for the cancellation of this agreement.</p>
        <p>1.2.您承诺接受并遵守本协议的商定。假如您不同意本协议的商定，点击不同意退出本次服务。</p>
        <p>You undertake to accept and abide by the agreement. If you do not agree with the agreement, Click disagree to
          exit the service.</p>
        <p>1.3.亦邦有权依据实际状况时常调整本协议和相关规章的内容，更改版本内容在本页面发布，请点击本服务条款时仔细阅读；服务条款及不时修订内容或更新版本内容自发布之日生效。</p>
        <p>Cititrans reserves the right to adjust the content of this Agreement and relevant regulations from time to time
          according to the actual situation. The Terms of Service and the contents amended or updated from time to time
          shall take effect as of the date of publication.</p>

        <p style="margin-top: 15px">2.为符合法律法规对货物运输安全的要求，保证货物运输安全送达，您在寄件时应履行以下义务。</p>
        <p>In order to meet the requirements of laws and regulations on the safety of cargo transportation and ensure the
          safe delivery of cargo transportation, you shall perform the following obligations when sending the cargo.</p>
        <p>2.1.确保货物不包含国家机关公文、国家保护野生动物及制品、假冒伪劣和侵权物品等法律法规禁止和限制运输物品，不得通过运输渠道危害国家安全、公共安全；不得运输国家法律法规明令禁止出口和目的国明令禁止进口物品。</p>
        <p>To ensure that goods do not contain official documents of state organs, wildlife and products under state
          protection, fake and shoddy goods and infringing goods prohibited or restricted by laws and regulations, and
          shall not endanger national security and public security through transportation channels; It is prohibited to
          transport articles whose export is prohibited by national laws and regulations and whose import is prohibited by
          the destination country.</p>
        <p>2.2.如实申报货物的品名、属性、数量和价值，并准确填写寄件人、收件人的名称、地址、联系电话等信息。</p>
        <p>Truthfully declare the name, attribute, quantity and value of the goods, and accurately fill in the name,
          address, contact telephone number and other information of senders and receivers.</p>
        <p>2.3.配合进行开箱验视,亦邦有权对收取货物进行开箱验视和拍照取证，确保运输货物不违反国家法律法规禁运要求，如发现违反国家法律法规的物品，有权移交到相关部门处理。
          Cooperate with the unpacking inspection, Cititrans has the right to unpacking inspection and take photos of the
          received goods to ensure that the goods do not violate the embargo requirements of national laws and
          regulations, if found in violation of national laws and regulations, have the right to transfer to the relevant
          departments.</p>

        <p style="margin-top: 15px">3.因运输货物属于或含有禁止或限制运输物品而被查没，扣留、空仓、罚款等，给亦邦或第三方造成经济损失的，您应承担赔偿责任。</p>
        <p>If the transported goods are or contain prohibited or restricted items and are confiscated, detained, empty
          warehouses, fines, etc., which cause economic losses to Cititrans or a third party, you shall be liable for
          compensation.</p>

        <p style="margin-top: 15px">4.因违禁品引发的安全事故，承担经济赔偿的同时依照国家法律法规还需要承担相应的法律责任。</p>
        <p>In case of safety accidents caused by contraband goods, economic compensation shall be borne while
          corresponding legal liabilities shall be borne in accordance with national laws and regulations.</p>

        <p style="margin-top: 15px">5. 关于货物理赔方案About the cargo claim scheme</p>
        <p>5.1. 保丢不保损 Pay for lost, but not for damaged</p>
        <p>5.1.1.货物运输途中外箱或内物破损造成的损失，亦邦不予赔偿。</p>
        <p>Cititrans will not compensate for any damage caused by damage to the outer container or contents of the goods
          during transit.</p>
        <p>5.1.2.亦邦对货物部分丢失、全部丢失给予赔偿，依据货物价值双方协商处理，最高赔偿运费两倍（含已付运费），增值服务产生的费用不予赔偿。</p>
        <p>Cititrans will pay compensation for partial or total loss of goods, which shall be handled by both parties
          through negotiation based on the value of goods. The maximum compensation is twice the freight (including the
          paid freight). No compensation will be paid for the cost of value-added services.</p>
        <p>5.2. 延误赔偿说明 Explanation of compensation for Delay</p>
        <p>5.2.1. 因时效延误产生的损失，亦邦不承担任何赔偿。</p>
        <p>Cititrans shall not be liable for any damages arising from the delay of limitation.</p>
        <p>5.3. 免责说明 Disclaimer</p>
        <p>5.3.1. 因台风、地震、洪灾、暴风雪、海啸、泥石流、战争、暴乱、疫情、政府管制等不可抗力导致的货物灭失、短少的情况。</p>
        <p>Loss or shortage of goods caused by force majeure such as typhoon, earthquake, flood, snowstorm, tsunami,
          mud-rock flow, war, riot, epidemic disease, government control, etc.</p>
        <p>5.3.2.其它法律法规或者双方约定亦邦免于赔偿的。</p>
        <p>Other laws and regulations or mutual agreement exempting Cititrans from compensation.</p>

        <p style="margin-top: 15px">6. 货物测量和检查 Goods survey and inspection</p>
        <p>6.1.亦邦将按照货物实际重量和体积重量中较高者计算基础运费，实际计算费用以报价表为准。</p>
        <p>Cititrans will calculate the base freight based on the higher of the actual weight and volume weight of the
          goods，the actual calculated expenses shall be subject to the quotation.</p>
        <p>6.2.在货物到达仓库后或签收前，亦邦可以对任何一件货物重新称重和测量，以确认其计算数据。</p>
        <p>Cititrans can re-weigh and measure any item after it arrives at the warehouse or before it is signed for
          collection to confirm its calculated data.</p>

        <p style="margin-top: 15px">7. 留置权Line</p>
        <p>
          若您或您指定的付款人未付清费用的，亦邦有权留置货物，留置后您的债务履行期限为2个月（货物到达之日起计算），但货物不能留置的除外。债务履行期限届满，您或指定付款人仍未付清费用的，亦邦可以变卖、拍卖留置物品优先受偿。变卖、拍卖所得价款应优先支付亦邦为行使留置权所支出的费用和保管费，再偿付拖欠亦邦的费用；如有余额，可根据您的要求汇至您指定账户。
        </p>
        <p>If you or your designated payer fail to pay the payment, Cititrans has the right to place a lien on the goods.
          After the lien, your debt performance period will be 2 months (counting from the date of arrival of the goods),
          unless the goods cannot be placed on lien. If you or the designated payer still fail to pay the debt at the
          expiration of the debt performance period, Cititrans may sell and auction the lien items to be paid first. The
          proceeds from sale and auction shall give priority to paying Cititrans's expenses and storage fees for
          exercising the lien, and then reimburse Cititrans's arrears. Balance, if any, can be remitted to your designated
          account upon your request.</p>

        <p style="margin-top: 15px">8. 货物销毁The goods destroyed</p>
        <p>若您对货物声明放弃、销毁，出具货物相关放弃、销毁证明，您不可就该货物再向亦邦主张任何权利，亦邦不再对此承担任何责任。</p>
        <p>If you declare abandonment and destruction of the goods, and issue relevant abandonment and destruction
          certificates of the goods, you cannot claim any rights against Cititrans on the goods, and Cititrans will no
          longer assume any responsibility for this.</p>

        <p style="margin-top: 15px">9. 如果本条款中的某条款被法院或政府机构认定为无效或部分无效，则双方同意除无效条款外仍应执行本合同其它条款、部分有效条款在其可执行的范围内仍继续执行。</p>
        <p>If any provision of this article is held to be invalid or partially invalid by a court or government agency,
          both parties agree that except the invalid provision, other provisions of this Contract shall be executed and
          some valid provisions shall be executed to the extent that they are enforceable.</p> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import qs from "qs";
import serviceAgreement from '../../../common/serviceAgreement.vue'
export default {
  components: { serviceAgreement },
  data() {
    return {
      transportTypeCode: JSON.parse(localStorage.getItem("transportTypeCode")),
      policyDialog: false,
      content: "",
      getgoodsremarks: "",
      recgoodremarks: "",
      customerNo: '',
      delgoodsremarks: "",
      dialogTableVisible: false,
      checkedQd: true,
      fullscreenLoading: false,
      goodsData: {
        cbm: 0,
        num: 0,
        weight: 0,
        piece: 0,
      },
      countLIst_S: JSON.parse(localStorage.getItem("countLIst_S")),
      countLIst_T: localStorage.getItem("countLIst_T") ? JSON.parse(localStorage.getItem("countLIst_T")) : null,
      boxLIst: JSON.parse(localStorage.getItem("boxLIst")),
      todoordate: null,
      formData: [],
      auto_fixed: false,
      Citydata: null,
      fromFABck: null,
      guojiaData: null,
      FBATransmoney: {
        checked: true,
        feeCode: "QBHYF",
        feeType: "Q",
        price: "", //--单价
        currency: "",
        cnycurrency: "", //现有币种
        cnyprice: "", //--单价
        cnyamount: "", //现有总价
        amount: "",
        piece: "1",
        price_unit: "",
        goodsTypeFeeDTOS: [],
      },
      isGlobalDelivery: false, //是否属于全境派送产品
      isGlobalSea: false, //是否属于全境派送海运产品
      GlobalDelivery: {
        //全境派送费
        amount: "",
        cnyamount: "",
        currency: "",
        piece: "",
        price: "",
        calDesc: "",
      },
      THFdata: {
        //提货费
        checked: false,
        feeCode: "THF",
        price: "",
        currency: "",
        cnyprice: "",
        cnycurrency: "",
        cnyamount: "",
        amount: "",
        piece: 1,
        boxtable: [],
      },
    };
  },
  watch: {},
  computed: {
    // 箱数统计
    getBoxNum() {
      return this.$store.state.goodsValueCount.boxNum
    },
    // 货值统计
    getGoodsValue() {
      return this.$store.state.goodsValueCount.proValue
    },
    // 综合判断是否隐藏保价无忧模块--是大客户、电商、非陆运--在隐藏保价无忧模块的同时，重新计算预估保费模块
    comIsFitBigCus() {
      //  是否大客户
      let isBigCustomer = this.$store.state.isBigCustomer
      // 是否电商
      let getProductType = this.calIndexTab()
      let isOnRetailers = getProductType.sonType == 3
      // 是否陆运
      let isLandTrans = localStorage.getItem("transportTypeCode") == 'LY'
      return isBigCustomer && isOnRetailers && !isLandTrans
    },
    calculatePrice() {
      //计算总费用
      let Totalmoney = 0; //总费用
      let FBATransmoney = 0; //运输费
      let THFmoney = 0; //提货费
      let GlobalDeliveryCny = 0; //全境派送费
      if (this.THFdata.checked) {
        //如果有提货费
        THFmoney = this.THFdata.cnyamount ? +this.THFdata.cnyamount : 0;
      }
      // if (this.isGlobalDelivery && !this.isGlobalSea) {
      //   //如果有全境派送费
      //   GlobalDeliveryCny = this.GlobalDelivery.cnyamount ? +this.GlobalDelivery.cnyamount : 0;
      // }
      FBATransmoney = this.FBATransmoney.cnyamount ? +this.FBATransmoney.cnyamount : 0;
      Totalmoney = FBATransmoney + THFmoney + GlobalDeliveryCny + this.formData.amount;
      return Totalmoney.toFixed(2);
    },
    BoxShowLable() {
      let boxLIst = JSON.parse(localStorage.getItem("boxLIst"))
      let goodTypelist = []
      let newArray = boxLIst.reduce((total, cur, index) => {
        let hasValue = total.findIndex((item) => {
          return item.goodstypeid === cur.goodstypeid;
        });
        hasValue === -1 && total.push(cur);
        hasValue !== -1 && (total[hasValue].weight = this.accAdd(total[hasValue].weight, cur.weight));
        hasValue !== -1 && (total[hasValue].cbm = this.accAdd(total[hasValue].cbm, cur.cbm));
        hasValue !== -1 && (total[hasValue].goodsDTOnum = this.accAdd(total[hasValue].goodsDTOnum, cur.goodsDTOnum));
        hasValue !== -1 && (total[hasValue].boxNum = this.accAdd(total[hasValue].boxNum, cur.boxNum));
        return total;
      }, []);
      console.log(newArray)
      return newArray
    },
    newArray() {
      //监听 币种
      let monetTypelist = []; //当前勾选的币种
      let totalMolist = []; //新对象
      let totalFeiyong = []; //当前勾选
      totalFeiyong.push(JSON.parse(JSON.stringify(this.FBATransmoney))); //海运费币种
      if (this.THFdata.checked) {
        totalFeiyong.push(JSON.parse(JSON.stringify(this.THFdata))); //提货费费币种
      }
      // if (this.isGlobalDelivery && !this.isGlobalSea) {
      //   totalFeiyong.push(JSON.parse(JSON.stringify(this.GlobalDelivery))); //全境派送
      // }
      this.formData.feeItemDTOS.forEach((item) => {
        if (item.checked && item.feeCode != 'INS') {
          totalFeiyong.push(JSON.parse(JSON.stringify(item)));
        }
      });
      let add = '+'
      let newArray = totalFeiyong.reduce((total, cur, index) => {
        let hasValue = total.findIndex((current) => {
          return current.currency === cur.currency;
        });
        hasValue === -1 && total.push(cur);
        hasValue !== -1 && (total[hasValue].amount = this.accAdd(total[hasValue].amount, cur.amount));
        return total;
      }, []);
      return newArray;
    },
  },
  methods: {
    // 整合首页参数
    calIndexTab() {
      let getProductType = JSON.parse(localStorage.getItem("productType"))
      if (!getProductType) {
        getProductType = JSON.parse(this.$store.state.productType)
        if (!getProductType) {
          return this.returnIndex()
        }
        return getProductType
      }
      return getProductType
    },
    // 返回首页
    returnIndex() {
      this.$message.warning("数据异常,请重新下单!")
      localStorage.clear();
      this.$router.push("/index/placeOrder/placeIndex");
      this.$store.state.Authorization = null;
    },
    openPolicy() {
      this.policyDialog = true;
    },
    accAdd(arg1, arg2) {
      //加法精度
      var r1, r2, m;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      m = Math.pow(10, Math.max(r1, r2));
      return (arg1 * m + arg2 * m) / m;
    },
    // getShowcount() {
    //   this.busLcljobsBeforeGoodsDTOList.forEach((item) => {
    //     this.goodsData.weight += parseFloat(+item.weight);
    //     this.goodsData.cbm += parseFloat(+item.cbm);
    //     this.goodsData.piece += parseFloat(item.piece);
    //   });
    // },
    pathToback() {
      this.$router.go(-1);
    },
    Qdshowcount() {
      if (!this.checkedQd) {
        return this.$message({
          showClose: true,
          message: this.$t("i18n_agree_agreement_first"),
          type: "error",
        });
      }
      this.dialogTableVisible = true;
    },

    pathToNext() {
      //下单
      let finaArapFbxBeforeYSFDTO = JSON.parse(localStorage.getItem("FBATransmoney"))//海运费
      let finaArapFbxBeforeTHFDTO = JSON.parse(localStorage.getItem("THFdata"));
      let finaArapFbxBeforeDTOList = []
      if (localStorage.getItem("FeeLIst")) {
        finaArapFbxBeforeDTOList = JSON.parse(localStorage.getItem("FeeLIst")).feeItemDTOS
        // 隐藏保价无忧模块后计算预估保费
        if (this.comIsFitBigCus && !finaArapFbxBeforeDTOList.some(item => { return item.remark == '预估保费' })) {
          // this.calPreSafeFee()
          let getFinaInsuranceDTO = JSON.parse(localStorage.getItem('finaInsuranceDTO'))
          finaArapFbxBeforeDTOList.push({
            amount: getFinaInsuranceDTO.feeCNY,
            basePriceDesc: "",
            calDesc: getFinaInsuranceDTO.calDesc,
            checked: true,
            currency: 'CNY',
            declarePriceDesc: '',
            feeCode: 'INS',
            feeName: '预估保费',
            iconUrl: '',
            num: '',
            priceDesc: '',
            remark: '预估保费'
          })
        }
      }

      const loading = this.$loading({
        lock: true,
        text: "下单中请稍等...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let that = this;
      let toFABck = JSON.parse(localStorage.getItem("toFABck")) //目的地仓库
      let recwarehouseDTO = {
        "recgoodscity": toFABck.city,
        "recgoodscountry": toFABck.country,
        "recremarks": this.recgoodremarks,
        "recwarehouseaddress": toFABck.address,
        "recwarehousecode": toFABck.namec
      }
      let params = {};
      let deliveryFbxAddressDTO = {
        "getgoodsname": this.countLIst_T ? this.countLIst_T.name : '',
        "getgoodstel": this.countLIst_T ? this.countLIst_T.tel : '',
        "getgoodsprovince": this.countLIst_T ? this.countLIst_T.parvince : '',
        "getgoodscity": this.countLIst_T ? this.countLIst_T.city : '',
        "getgoodsarea": this.countLIst_T ? this.countLIst_T.area : '',
        "getgoodsaddress": this.countLIst_T ? this.countLIst_T.address : '',
        "getremarks": this.getgoodsremarks //提货备注
      }

      //对跨境派送数据进行封装判断
      let globalDeliveryDTO = null
      let receiveGoodsDTO = null
      if (this.isGlobalDelivery) {
        globalDeliveryDTO = JSON.parse(localStorage.getItem('GlobalDelivery'))
        receiveGoodsDTO = {
          receiveGoodsId: JSON.parse(localStorage.getItem('countLIst_C')).id,
          receiveGoodsName: JSON.parse(localStorage.getItem('countLIst_C')).name,
          receiveGoodsTel: JSON.parse(localStorage.getItem('countLIst_C')).tel,
          receiveGoodsCountry: JSON.parse(localStorage.getItem('countLIst_C')).country,
          receiveGoodsCity: JSON.parse(localStorage.getItem('countLIst_C')).city,
          receiveGoodsArea: JSON.parse(localStorage.getItem('countLIst_C')).area,
          receiveGoodsAddress: JSON.parse(localStorage.getItem('countLIst_C')).address,
        }
      } else {
        globalDeliveryDTO = {
          //全境派送费
          amount: "",
          cnyamount: "",
          currency: "",
          piece: "",
          price: "",
          calDesc: "",
        }
        receiveGoodsDTO = {
          receiveGoodsId: 0,
          receiveGoodsName: "",
          receiveGoodsTel: "",
          receiveGoodsCountry: "",
          receiveGoodsCity: "",
          receiveGoodsArea: "",
          receiveGoodsAddress: "",
        }
      }

      let finaInsuranceDTO = null
      if (localStorage.getItem('finaInsuranceDTO')) {
        finaInsuranceDTO = JSON.parse(localStorage.getItem('finaInsuranceDTO'))
      }
      else {
        finaInsuranceDTO = {
          calDesc: '',
          checked: false,
          feeCNY: '',
          insuranceQuoteId: '',
          insuranceRate: "",
          isSpecialGoods: '',
          specialGoods: null,
          totalGoods: '',
          totalPiece: "",
          valueAvgCNY: "",
          valueLowestUSD: "",
          valueRate: "",
          valueTotalCNY: "",
          valueTotalUSD: "",
          valuehighestUSD: ""
        }
      }

      params = {
        "customerNo": this.customerNo, // 备注客户单号
        "busFbxjobsBeforeBoxDTOList": JSON.parse(localStorage.getItem("boxLIst")),
        "customerid": JSON.parse(sessionStorage.getItem("Authorization")).customerid, //客户id
        "shipperAddressId": JSON.parse(localStorage.getItem("countLIst_S")).id, // 发货信息
        "deliveryFbxAddressDTO": deliveryFbxAddressDTO, //提货地址
        "finaArapFbxBeforeDTOList": finaArapFbxBeforeDTOList, //增值服务
        "finaArapFbxBeforeTHFDTO": JSON.parse(localStorage.getItem("THFdata")), //提货费
        "finaArapFbxBeforeYSFDTO": JSON.parse(localStorage.getItem("FBATransmoney")), //运输费  ,
        "isGlobalDelivery": this.isGlobalDelivery, //是否存在跨境派送费用
        "globalDeliveryDTO": globalDeliveryDTO, //跨境派送费  ,
        "receiveGoodsDTO": receiveGoodsDTO,   //收货信息
        "finaInsuranceDTO": finaInsuranceDTO,//保险服务费
        "inwarehouseTime": localStorage.getItem("inwarehousetime") ? localStorage.getItem("inwarehousetime") : "", //入仓时间
        "asn": localStorage.getItem("FBAOmsasn") ? localStorage.getItem("FBAOmsasn") : '',
        "inwarehouseid": this.fromFABck.id,
        "isgetgoodstodoor": JSON.parse(localStorage.getItem("THFdata")).checked,
        "recwarehouseDTO": recwarehouseDTO,
        "saleid": JSON.parse(sessionStorage.getItem("Authorization")).salesid,
        "source": 'WEB',
        "todoordate": localStorage.getItem("todoorTime") ? localStorage.getItem("todoorTime") : "",
        "towarehouseid": toFABck.id,
        "transportTypeCode": JSON.parse(localStorage.getItem("transportTypeCode")),
        "delremarks": JSON.parse(localStorage.getItem("delgoodsremarks")),
        delgoodsname: this.countLIst_S ? this.countLIst_S.name : "",
        delgoodstel: this.countLIst_S ? this.countLIst_S.tel : "",
        productId: Number(localStorage.getItem("checkProductId"))
      };
      // 根据isGlobalDelivery判断，为true就传俩参数
      if (JSON.parse(localStorage.getItem('isGlobalDelivery'))) {
        params['bestSendWay'] = JSON.parse(localStorage.getItem('bestSendWay'))
        params['deliveryService'] = localStorage.getItem('deliveryService')
        params['deliveryQuoteId'] = localStorage.getItem('deliveryQuoteId')
      }
      this.axios
        .post(`/busFbx/createFbxjobsBefore`, params)
        .then((res) => {
          if (res.data.code == "200") {
            loading.close();
            localStorage.removeItem('customerNo')
            // 重置货值与箱数
            this.$store.commit("setGoodsValue", {
              proValue: 0
            })
            this.$store.commit("setGoodsCount", {
              boxNum: 0
            })
            this.$router.push({
              name: "FbaorderSuccess",
              query: {
                state: 1,
                innos: res.data.data.innos,
                nos: res.data.data.innos,
              },
            });
            localStorage.setItem('deliveryQuoteId', '')
            localStorage.setItem('deliveryService', '')
          } else {
            loading.close();
            this.$message({
              showClose: true,
              message: res.data.message,
              type: "error",
            });
          }
        })
        .catch((res) => {

        });
    },
    onScroll() {
      // 计算滚动的距离
      let scrolled =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 计算A区的高度
      let header_height = null;
      if (document.getElementsByClassName("wrap_R")[0]) {
        header_height = document.getElementsByClassName("wrap_R")[0]
          .offsetHeight;
      }
      if (scrolled >= 200) {
        this.auto_fixed = true;
      } else {
        this.auto_fixed = false;
      }
    },
  },
  created() {
    this.Citydata = JSON.parse(localStorage.getItem("Citydata"));
    this.fromFABck = JSON.parse(localStorage.getItem("fromFABck"));
    this.toFABck = JSON.parse(localStorage.getItem("toFABck"));
    this.getgoodsremarks = JSON.parse(localStorage.getItem("getgoodsremarks"));
    this.recgoodremarks = JSON.parse(localStorage.getItem("recgoodremarks"));
    this.customerNo = JSON.parse(localStorage.getItem('customerNo'))
    this.delgoodsremarks = JSON.parse(localStorage.getItem("delgoodsremarks"));
    if (localStorage.getItem("FBATransmoney")) {
      //海运费
      this.FBATransmoney = JSON.parse(localStorage.getItem("FBATransmoney"));
    }
    if (localStorage.getItem("THFdata")) {
      //提货费
      this.THFdata = JSON.parse(localStorage.getItem("THFdata"));
    }
    if (localStorage.getItem("GlobalDelivery")) {
      //跨境运输费
      this.GlobalDelivery = JSON.parse(localStorage.getItem("GlobalDelivery"));
    }
    if (localStorage.getItem("isGlobalDelivery")) {
      this.isGlobalDelivery = JSON.parse(localStorage.getItem("isGlobalDelivery"));
    }
    // 是否为全境派送海运
    this.isGlobalSea = this.$store.state.productInfo.transportTypeCode == 'HY' && this.$store.state.productInfo.isGlobalDelivery
    if (localStorage.getItem("FeeLIst")) {
      this.formData = JSON.parse(localStorage.getItem("FeeLIst"));
    }
    if (localStorage.getItem("todoorTime")) {
      //如果有选择提货费
      this.todoordate = localStorage.getItem("todoorTime");
      this.countLIst_T = JSON.parse(localStorage.getItem("countLIst_T"));
    }
  },
  mounted() {
    this.$nextTick(function () {
      //监听滚动
      window.addEventListener("scroll", this.onScroll);
    });
    // this.getShowcount();
  },
};
</script>
<style scoped>
.btnstyle {
  width: 150px;
  height: 35px;
  background: #ffffff;
  border: 2px solid #dcdcdc;
  border-radius: 35px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.Qdbtn {
  width: 100%;
  padding: 0 60px;
  box-sizing: border-box;
}

.fontString {
  font-weight: bold;
}

.shouMargin {
  margin-bottom: 10px;
}

.ckttext {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #9a9a9a;
}

.good_count {
  margin-top: 65px;
}

.header_text {
  text-align: center;
  width: 100%;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}

.count {
  width: 100%;
  padding-top: 30px;
}

.dialog >>> .el-dialog__body {
  padding: 0px 30px 30px 30px !important;
}

.dialog >>> .el-dialog__header {
  padding: 10px !important;
}

.tittype {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  margin-left: 10px;
}

.auto_fixed {
  position: fixed;
  top: 20px;
  margin-left: 778px;
}

/* 左右对齐 */
.LR_center {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
}

.popWrap_l {
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  flex-flow: row nowrap;
  justify-content: space-between;
}

/* 垂直居中 */
.count_center {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  /* column垂直 */
  flex-direction: column;
}

.Item_Right {
  float: left;
}

.Item_Right .tit {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #343434;
}

.littit {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
}

.coutText {
  margin-top: 9px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.Item_Right {
  width: 100%;
  float: left;
  padding: 15px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #e7e7e7;
}

.center_wrap {
  width: 1280px;
  margin: 0 auto;
}

.Item_list {
  width: 100%;
  float: left;
  padding: 24px 28px 12px 28px;
  box-sizing: border-box;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
  margin-bottom: 15px;
}

.header_wrap {
  width: 100%;
  height: 121px;
  margin-top: 33px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}

.wrap_l {
  float: left;
  width: 875px;
  background: #ffffff;
  box-sizing: border-box;
  padding-bottom: 50px;
}

.wrap_R {
  float: right;
  width: 380px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
}

.cangkutit {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
  float: left;
}

.el-row {
  margin-bottom: 20px;
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

/* table 滚动条 */
.OrderDetails {
  max-height: 500px;
  overflow: auto;
  overflow-x: hidden;
}

.OrderDetails::-webkit-scrollbar {
  width: 3px;
}

.OrderDetails::-webkit-scrollbar-thumb {
  border-radius: 2px;
  height: 50px;
  background: #409eff;
}

.OrderDetails::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  background: #eee;
}

/* 货值统计 */
.goodsValueCount {
  box-sizing: border-box;
  width: 100%;
  float: left;
  padding-top: 10px;
  color: #f86670;
}
.goodsValue_fat {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-top: 10px;
}
.goodsValue_name {
  font-size: 14px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/FBAorder/Fbaqdbill.vue